import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface Tenant {
  tenant_id: string;
  name_en?: string;
  title?: string;
}

interface DuplicatePickemDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (tenantId: string) => void | Promise<void>;
  tenants: Tenant[];
  isLoading?: boolean;
}

export function DuplicatePickemDialog({
  open,
  onOpenChange,
  onConfirm,
  tenants,
  isLoading = false,
}: DuplicatePickemDialogProps) {
  const [selectedTenantId, setSelectedTenantId] = useState<string>('');

  const handleConfirm = async () => {
    if (!selectedTenantId) return;
    await onConfirm(selectedTenantId);
    setSelectedTenantId('');
    onOpenChange(false);
  };

  const handleCancel = () => {
    setSelectedTenantId('');
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Duplicate Pickem</DialogTitle>
          <DialogDescription>
            Select a tenant to assign the duplicated pickem to. All questions and options will be
            copied.
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col gap-2 py-4">
          <Label htmlFor="tenant-select">Target Tenant *</Label>
          <Select value={selectedTenantId} onValueChange={setSelectedTenantId}>
            <SelectTrigger id="tenant-select">
              <SelectValue placeholder="Select a tenant" />
            </SelectTrigger>
            <SelectContent>
              {tenants.map(tenant => (
                <SelectItem key={tenant.tenant_id} value={tenant.tenant_id}>
                  {tenant.name_en || tenant.title || `Tenant #${tenant.tenant_id}`}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={handleCancel} disabled={isLoading}>
            Cancel
          </Button>
          <Button onClick={handleConfirm} disabled={!selectedTenantId || isLoading}>
            {isLoading ? 'Duplicating...' : 'Duplicate Pickem'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
